import { render, staticRenderFns } from "./ManageStoreAdd.vue?vue&type=template&id=2844fee4&"
import script from "./ManageStoreAdd.vue?vue&type=script&lang=js&"
export * from "./ManageStoreAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports